import {
    Input,
    Component,
    forwardRef,
    ViewChild
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { MODAL_EDITOR_TOKEN, ModalEditorBase } from '../../../classes/modal-editor-base';
import { ModalEditorWrapperComponent } from 'account-shared';

@Component({
    selector: 'ft-monthly-daterange-editor',
    templateUrl: './monthly-daterange-editor.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => MonthlyDaterangeEditorComponent)
        },
        {
            provide: MODAL_EDITOR_TOKEN,
            useExisting: MonthlyDaterangeEditorComponent
        }
    ],
    standalone: false
})
export class MonthlyDaterangeEditorComponent extends ModalEditorBase {
    @Input() theme: 'dark' | 'light' | 'gray' = 'dark';
    @Input() fixedRangeDays?: number;
    @ViewChild(ModalEditorWrapperComponent) editorWrapper: ModalEditorWrapperComponent;

    constructor() {
        super();
    }

    onDateRangeChanged(dateRange: { startDate: Date, endDate: Date }) {
        this.value = dateRange;
        this.editorWrapper.onSave();
    }
}

